import type {HotelDetails} from '@/api/hoteldetails';
import type {
  HotelListEcommerceItem,
  HotelListItem,
} from '@/redux/middleware/googleTagManager/types';

import {mapHotelCategory} from '@/redux/middleware/googleTagManager/utils/mapHotelCategory';
import {mapHotelSpecials} from '@/redux/middleware/googleTagManager/utils/mapHotelSpecials';
import {mapToSortListNameForHotel} from '@/redux/middleware/googleTagManager/utils/mapToSortListNameForHotel';

export const mapHotelDataToEcommerceItem = (
  hotelListItem: HotelListItem,
  sortBy: string,
  hotelDetails?: HotelDetails,
  isMap = false,
  isWishlist = false
): HotelListEcommerceItem => {
  let itemListName = mapToSortListNameForHotel(sortBy);
  if (isWishlist) {
    itemListName = 'wishlist';
  } else if (isMap) {
    itemListName = 'hotel list - map';
  }

  return {
    item_name: hotelDetails?.name || '',
    item_id: hotelListItem.id,
    price: hotelListItem.price.amount / 100,
    currency: hotelListItem.price.currency,
    item_list_name: itemListName,
    item_category: mapHotelCategory(
      hotelDetails?.category,
      hotelDetails?.categoryType
    ),
    item_category2: mapHotelSpecials(hotelListItem.specials),
    item_category4: '',
    item_brand: '',
    item_sustainability: hotelDetails?.isSustainable ? '1' : '0',
    index: hotelListItem.position,
    location_id: '',
    quantity: 1,
  };
};
